import styled from "styled-components";



export const AlertDialogModal = styled.div`
  min-width: 450px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

export const AlertDialogTitle = styled.div`
  font-size: var(--general-header-font-size);
  color: var(--font-color-blue002e5c);
  font-weight: var(--general-header-font-weight);
`;

export const AlertDialogDescription = styled.p`
  font-size: var(--general-large-body-font-size);
  color: var(--font-color-blue002e5c);
  font-weight: var(--general-large-body-font-weight);
  width: 90%;
  text-align: center;
`;

export const AlertDialogActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
`


export const AlertDialogButton = styled.button`
    height: 44px;
    border-radius: 5px;
    padding: 0 1rem;
    min-width: 100px;
    font-size: var(--general-button-font-size);
    font-weight: var(--general-button-font-weight);
    font-family: var(--general-button-font-family);
    background-color: ${({ theme }) => theme === "primary" ? "#2555EF" : "#2555ef14"};
    color: ${({ theme }) => theme === "primary" ? "#FFFFFF" : "#2555EF"};

    opacity: ${({ disabled }) => disabled ? "0.5" : "1"};
`;